import type { AppProps } from 'next/app';
import Script from 'next/script';

import { PulseToGtmSync } from 'shared/pulse';

/*
    This is a virtual import, i.e. `uno.css` will never be present anywhere on the disk. It is handled by the `UnoCSS` webpack plugin
    setup in `next.config.mjs`. This plugin creates a `<style>` section with all the extracted styles in the html in development, and
    creates a hashed css file in production.
 */
import 'uno.css';
import { UnleashProvider } from '@/hooks/unleash';

declare global {
    interface Window {
        TrackJS?: {
            install: (data: { token: string; application: string; version: string; enabled: boolean }) => void;
        };
    }
}

const LotrApp = ({ Component, pageProps }: AppProps) => (
    <>
        <UnleashProvider toggles={pageProps.unleash}>
            <Component {...pageProps} />
        </UnleashProvider>
        <Script
            src="https://cdn.trackjs.com/agent/v3/latest/t.js"
            onLoad={() => {
                window.TrackJS?.install?.({
                    token: '74bb3e28a1604fd2b28c72c568722d21',
                    application: 'finn-travel-lotr',
                    version: `'${process.env.NEXT_PUBLIC_GIT_COMMIT_SHA}'`,
                    enabled: location.host.indexOf('local') !== 0 && location.host.indexOf('127.0.0') !== 0,
                });
            }}
            crossOrigin=""
        />
        <PulseToGtmSync />
    </>
);

export default LotrApp;
